import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../auth';

function authInterceptorFactory(authService: AuthService): HttpInterceptor {
  return {
    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      // 1) Attach the token if available
      const token = authService.authToken;
      if (token) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });
      }

      // 2) Send the request and catch errors
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          // If we get a 401, attempt to refresh
          if (error.status === 401 && authService.canRefresh) {
            return authService.onRefresh().pipe(
              // After refresh, retry the request using the newly obtained token
              switchMap((newToken: string) => {
                const newRequest = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken}`,
                  },
                });
                return next.handle(newRequest);
              }),
            );
          }
          throw error;
        }),
      );
    },
  };
}

export const authInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useFactory: authInterceptorFactory,
    deps: [AuthService],
    multi: true,
  },
];
